import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { validatePhoneNumberMaskedTextBox } from '../../validators/validator';
import { Validators } from '@angular/forms';

export const AddStudentProfileFormModel: ISedmsFormModel = {
  firstName: {
    name: 'firstName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  middleName: {
    name: 'middleName',
  },
  lastName: {
    name: 'lastName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  dateOfBirth: {
    name: 'dateOfBirth',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  gender: {
    name: 'gender',
  },
  ethnicity: {
    name: 'ethnicity',
  },
  hispanicFlag: {
    name: 'hispanicFlag',
  },
  homeLanguage: {
    name: 'homeLanguage',
  },
  phoneNumber: {
    name: 'phoneNumber',
    validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
  },
  email: {
    name: 'email',
  },
  streetNumber: {
    name: 'streetNumber',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  streetName: {
    name: 'streetName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  borough: {
    name: 'borough',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  city: {
    name: 'city',
    validators: [{ validator: Validators.required }],
  },
  state: {
    name: 'state',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  zip: {
    name: 'zip',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  district: {
    name: 'district',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  apartmentNo: {
    name: 'apartmentNo',
  },
};
